import { forwardRef, Fragment } from "react";
import { StandardContainer } from "./Layout/StandardStyledComponents";

interface PageProps {
  title?: string;
  ref?: string;
  children: any;
  className?: string;
}
const Page = forwardRef<JSX.Element, PageProps>(
  ({ children, title = "", ...rest }, ref) => {
    return <Fragment>{children}</Fragment>;
  }
);

export default Page;
